export const ArticleTypes = {
  Mifare1K: 1,
  QRTiparit: 2,
  Ultralight: 3,
  Mifare1KExtern: 4,
};
